(function ($, undefined) {
    window.initMap = function () {
        const $map = $('.js-contact-map');

        const mapPosition = {lat: 47.014080840325, lng: 28.85455516390801};

        const map = new google.maps.Map($map[0], {
            mapId: '212b1dc8432b2dbe',
            zoom: 15,
            center: mapPosition
        });

        const $mapElements = $('.js-map-marker');
        const bounds = new google.maps.LatLngBounds();
        const points = [];

        $mapElements.each(function () {
            const $this = $(this),
                lat = $this.attr("data-location-lat"),
                lng = $this.attr("data-location-lng");

            const isMapElement = (lat.length && lng.length);

            if (isMapElement) {
                points.push({
                    position: {lat: +lat, lng: +lng}
                });
            }

            points.forEach(point => {
                const marker = new google.maps.Marker({
                    map,
                    position: point.position,
                    icon: '/wp-content/themes/project/assets/build/img/domus-pin.svg'
                });
                bounds.extend(marker.position);
            });

            map.fitBounds(bounds);
        });
    }
})(jQuery);